import React from "react"
export const WhistleContent = ({ content }) => {

	const removedContentString = content.split("Content: \n").pop()
	const removedDetails = removedContentString.split("\n\nContact information")[0]
	const finalContent = removedDetails.split("\n\nRequest for")[0]

	return (<>
		<div className="mb-3 border_radius_6px sibilus_border bg_light_grey p-5">
			<div className="mb-3">
				<h5 style={{ whiteSpace: "pre-line" }}>{finalContent}</h5>
			</div>
		</div>
	</>);
};

export default WhistleContent
